"use client";

import { LegalDocument } from "@/components/marketing/LegalDocument";

export default function RefundPolicyPage() {
  return (
    <LegalDocument
      titleKey="legal.refundTitle"
      introKey="legal.refundIntro"
      contactKey="legal.refundContact"
      sections={[
        { headingKey: "legal.refundS1Heading", bodyKey: "legal.refundS1Body" },
        { headingKey: "legal.refundS2Heading", bodyKey: "legal.refundS2Body" },
        { headingKey: "legal.refundS3Heading", bodyKey: "legal.refundS3Body" },
      ]}
    />
  );
}
